var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-connection-trouble"},[_c('div',{staticClass:"text-center"},[_c('h3',[_vm._v("We're having trouble connecting.")]),(_vm.retry)?_c('AxButton',{on:{"click":_vm.retry}},[_vm._v(" Retry ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }